import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2, Gift } from 'lucide-react';
import { Button } from './ui/Button';
export function FeaturesSection() {
  const features = ['Guía paso a paso con el plan de acción de 72 horas.', 'La Lista de los 7 Irritantes Invisibles: qué eliminar en la ventana nocturna para calmar la vejiga.', 'Técnica de Doble Vaciado: método físico para vaciar mejor en menos de 60 segundos.', 'Hidratación Estratégica: cómo beber sin convertir tu vejiga en un reloj despertador.', 'Guía de Suplementación de Emergencia: minerales clave para apoyar la relajación del sistema urinario.', 'Diario de Seguimiento: para medir progreso real noche a noche.'];
  return <section className="bg-navy-900 py-14 md:py-20 relative text-cream-50" data-id="element-55">
      <div className="container mx-auto px-4" data-id="element-56">
        <div className="max-w-[720px] mx-auto" data-id="element-57">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-58">
            <div className="w-12 h-px bg-gold-500/30" data-id="element-59" />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-500/50" data-id="element-60" />
            <div className="w-12 h-px bg-gold-500/30" data-id="element-61" />
          </div>
          <FadeIn data-id="element-62">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-10 text-center" data-id="element-63">
              Dentro del ebook "Protocolo Próstata: Noches en Paz", encontrarás:
            </h2>
          </FadeIn>

          <div className="bg-navy-800 rounded-2xl p-8 border border-navy-700 shadow-2xl mb-16" data-id="element-64">
            <div className="space-y-6" data-id="element-65">
              {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-66">
                  <div className="flex items-start gap-4" data-id="element-67">
                    <CheckCircle2 className="text-green-400 shrink-0 mt-1" size={24} data-id="element-68" />
                    <p className="text-lg text-cream-100/90" data-id="element-69">{feature}</p>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <FadeIn data-id="element-70">
            <p className="text-xl font-heading font-bold text-gold-400 text-center mb-10" data-id="element-71">
              Y si compras hoy, recibes 2 BONOS descargables sin costo adicional
              (para que no tengas que improvisar nada):
            </p>
          </FadeIn>

          <div className="space-y-8 mb-12" data-id="element-72">
            <FadeIn delay={0.1} data-id="element-73">
              <div className="bg-gradient-to-br from-navy-800 to-navy-900 rounded-2xl p-8 border-2 border-gold-500/30 relative" data-id="element-74">
                <div className="absolute -top-5 left-8 bg-gold-500 text-navy-950 font-bold px-4 py-1.5 rounded-lg shadow-lg flex items-center gap-2" data-id="element-75">
                  <Gift size={18} data-id="element-76" />
                  BONO #1
                </div>
                <h3 className="text-2xl font-heading font-bold text-white mt-4 mb-6" data-id="element-77">
                  Plan de Cenas Anti‑Nicturia (7 Días) + Recetas Express
                </h3>
                <ul className="space-y-4 text-cream-100/80 text-lg" data-id="element-78">
                  <li className="flex items-start gap-3" data-id="element-79">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-80" />
                    <span data-id="element-81">
                      Versión bajo en sodio por defecto (menos sed, menos
                      "llenado" nocturno)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-82">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-83" />
                    <span data-id="element-84">Lista de compras completa</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-85">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-86" />
                    <span data-id="element-87">Menú 7 noches + recetas simples</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-88">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-89" />
                    <span data-id="element-90">
                      Versión "Trabajo tarde": cenas de 5 minutos sin irritantes
                    </span>
                  </li>
                </ul>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-91">
              <div className="bg-gradient-to-br from-navy-800 to-navy-900 rounded-2xl p-8 border-2 border-gold-500/30 relative" data-id="element-92">
                <div className="absolute -top-5 left-8 bg-gold-500 text-navy-950 font-bold px-4 py-1.5 rounded-lg shadow-lg flex items-center gap-2" data-id="element-93">
                  <Gift size={18} data-id="element-94" />
                  BONO #2
                </div>
                <h3 className="text-2xl font-heading font-bold text-white mt-4 mb-6" data-id="element-95">
                  Guía de Emergencia "3AM" (Protocolo en 5 pasos)
                </h3>
                <ul className="space-y-4 text-cream-100/80 text-lg" data-id="element-96">
                  <li className="flex items-start gap-3" data-id="element-97">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-98" />
                    <span data-id="element-99">Qué hacer EXACTAMENTE cuando ya te despertaste</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-100">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-101" />
                    <span data-id="element-102">
                      Para volver a dormir más rápido sin activar el cerebro
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-103">
                    <div className="w-2 h-2 rounded-full bg-gold-400 mt-2.5 shrink-0" data-id="element-104" />
                    <span data-id="element-105">
                      Incluye "tarjeta" tipo checklist para usar medio dormido
                    </span>
                  </li>
                </ul>
              </div>
            </FadeIn>
          </div>

          <FadeIn delay={0.3} className="flex justify-center" data-id="element-106">
            <Button data-id="element-107">SÍ, QUIERO EL PROTOCOLO Y LOS BONOS</Button>
          </FadeIn>
        </div>
      </div>
    </section>;
}